import { Text, View } from 'react-native';

import { connectionBannerState } from '@/lib/sync/connection-banner-state';
import { useSyncConnection } from '@/lib/sync/use-connection';

/**
 * Sits at the top of the sidebar and tells the user when the app is running on
 * local data only. Hidden while online; auto-hides again once the connection
 * (and any queued local changes) sync back up.
 */
export function ConnectionBanner() {
  const connection = useSyncConnection();
  const state = connectionBannerState(connection);
  if (!state) {
    return null;
  }
  const isWarning = state.tone === 'warning';
  const containerClass = isWarning
    ? 'border-b border-danger bg-danger-muted px-1.5 py-1'
    : 'border-b border-warning bg-warning-muted px-1.5 py-1';
  const dotClass = isWarning ? 'h-1.5 w-1.5 rounded-full bg-danger' : 'h-1.5 w-1.5 rounded-full bg-warning';
  return (
    <View className={containerClass}>
      <View className="flex-row items-center gap-1">
        <View className={dotClass} />
        <Text className="text-[11px] font-semibold text-fg">{state.title}</Text>
      </View>
      <Text className="mt-0.5 text-[10px] leading-snug text-fg-muted">{state.detail}</Text>
    </View>
  );
}
